import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import Toggles from './toggles'
import FlightForm from './flight-form'

const OneOrManyFlights = props => {
  const [mode, setMode] = useState(0)
  const [from, setFrom] = useState('')
  const [to, setTo] = useState('')
  const [flightsCount, setFlightsCount] = useState(2)
  const [flightIds, setFlightIds] = useState([1])
  const [multipleDestinations, setMultipleDestinations] = useState({})
  const handleMutlipleToChange = (id, newTo) =>
    setMultipleDestinations({
      ...multipleDestinations,
      [id]: newTo,
    })

  // const swap = () => {
  //   const c = from
  //   setFrom(to)
  //   setTo(c)
  // }

  const gotoMode = index => {
    setMode(index)
    if (index !== 2) {
      setFlightsCount(2)
      setFlightIds([1])
    }
  }

  const addFlight = () => {
    setFlightIds([...flightIds, flightsCount])
    setFlightsCount(flightsCount + 1)
  }

  const removeFlight = id => {
    const i = flightIds.indexOf(id)
    flightIds.splice(i, 1)
    if (flightIds.length === 0) {
      gotoMode(0)
    } else {
      setFlightIds([...flightIds])
    }
  }

  const { t } = useTranslation()

  const button1 = props.button && (
    <>
      <button
        className='btn btn--f-14 visible-in-modal'
        onClick={props.button.onClickInModal}
        type='button'
      >
        {t('Continue')}
      </button>
      <button
        className='btn btn--f-14 visible-outside-of-modal'
        onClick={props.button.onClick}
        type='button'
      >
        {t('Request Quotes')}
      </button>
    </>
  )
  const button2 = props.button && (
    <>
      <button
        className='btn visible-in-modal'
        onClick={props.button.onClickInModal}
        type='button'
      >
        {t('Continue')}
      </button>
      <button
        className='btn btn--f-14 visible-outside-of-modal'
        onClick={props.button.onClick}
        type='button'
      >
        {t('Request Quotes')}
      </button>
    </>
  )

  return (
    <>
      <Toggles activeIndex={mode} onItemClick={gotoMode} />

      <div className={`grid-x ${props.spacerClass}`}>
        <div className='small-12 xlarge-auto cell'>
          <FlightForm
            from={from}
            onFromChange={setFrom}
            to={to}
            onToChange={setTo}
            flightIndex={0}
            withRightButton={mode === 0 && props.withRightButton}
          />
        </div>

        {mode === 0 && props.button && (
          <div className='small-12 xlarge-2 flex-container cell'>{button1}</div>
        )}
      </div>

      {/* {mode === 1 && (
        <button
          onClick={swap}
          type='button'
          className='small-circle-button small-circle-button--exchange'
        >
          &uarr;&darr;
        </button>
      )} */}

      {mode === 1 && (
        <FlightForm
          from={to}
          onFromChange={setTo}
          to={from}
          onToChange={setFrom}
          flightIndex={1}
          onCrossClick={removeFlight.bind(null, 1)}
          className={props.spacerClass}
        />
      )}

      {mode === 2 &&
        flightIds.map((id, index) => {
          const previousDestination = multipleDestinations[flightIds[index - 1]]
          return (
            <FlightForm
              flightIndex={id}
              key={id}
              onCrossClick={removeFlight.bind(null, id)}
              className={props.spacerClass}
              onToChange={newTo => handleMutlipleToChange(id, newTo)}
              defaultFrom={index === 0 ? to : previousDestination}
              defaultTo={previousDestination ? from : undefined}
            />
          )
        })}

      {mode === 2 && (
        <button
          onClick={addFlight}
          type='button'
          className='flex-container align-middle align-justify button__add button__add--form'
        >
          <span
            className='button__add-icon'
            style={{
              backgroundImage: `url(${window.themePath}images/add-button.svg)`,
            }}
          ></span>
          <span className='button__add-text'>{t('Add a destination')}</span>
        </button>
      )}

      {mode !== 0 && props.button && (
        <div className='grid-x align-right'>
          <div className='small-12 medium-3 xxlarge-2 cell'>{button2}</div>
        </div>
      )}
    </>
  )
}

OneOrManyFlights.propTypes = {
  button: PropTypes.shape({
    onClick: PropTypes.func,
    onClickInModal: PropTypes.func,
  }),
  spacerClass: PropTypes.string,
  withRightButton: PropTypes.bool,
}

OneOrManyFlights.defaultProps = {
  spacerClass: 'mb-8',
}

export default OneOrManyFlights
